import { fetchDashboard } from '~/services/dashboard';

export const useDashboard = () => {
    const { data, isLoading, request } = useApiData(async () => {
        return await fetchDashboard();
    });

    return {
        data,
        isLoading,
        request,
    };
};
